export class Document {

    constructor(
        public Description: string,
        public IconSrc: string,
        public Fecha?: Date,
        public TipoActuacion?: string,
        public GrabacionId?: number,
        public DocumentoId?: number,
        public Recording?: string,
        public Document?: string,
        public FAlta?: Date,
        public FCierre?: Date
    ) {

    }
}